module.exports = __webpack_public_path__ + "static/media/logo.bca40d37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 130
// module chunks = 0